import { handleSessionLessApi } from "./common";

const MOST_BOUGHT_STOCKS_API_ENDPOINTS = {
	stocks: `/most/bought/stocks`,
};

export const get_most_bought_scrip = async (Api, params) => {
	try {
      const res = await Api.get(MOST_BOUGHT_STOCKS_API_ENDPOINTS.stocks, params);
	  return handleSessionLessApi(res);
	} catch(e) {
      throw new Error('error in most bought stocks api');
	}
}